<div class="content">
  <div class="header">
    Иконки, которые есть в проекте
    <div class="grey-text">
      Используется библиотека @ngneat/svg-icon. Об использовании, кастомизации и прочем идите на
      гитхаб
    </div>
  </div>

  <div class="icons">
    <div class="subheader">Иконки</div>
    <svg-icon *ngFor="let icon of icons" [key]="icon" [attr.key]="icon"></svg-icon>
  </div>

  <div class="images">
    <div class="subheader">Изображения</div>
    <svg-icon *ngFor="let icon of bigIcons" [key]="icon" [attr.key]="icon"></svg-icon>
  </div>
</div>
